import { DespatchProduct } from "../models/despatch";
import BaseService from "./_base.service";

const endpoint = "despatches/products";

const DespatchProductService = {
  ...BaseService<DespatchProduct>({ endpoint }),
};

export default DespatchProductService;
